/* FG — Delivery countdown (Asia/Dubai, no DST). Plain init — does not depend on
   custom-element upgrade timing, so it always runs. */
(function () {
  function dubaiSeconds() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Dubai',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).formatToParts(new Date());
    var h = 0, m = 0, s = 0;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
      else if (p.type === 'minute') m = parseInt(p.value, 10);
      else if (p.type === 'second') s = parseInt(p.value, 10);
    }
    return h * 3600 + m * 60 + s;
  }

  function update(el) {
    var line = el.querySelector('[data-countdown-line]');
    if (!line) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 12;
    var city = el.getAttribute('data-city') || 'Dubai';
    var before = el.getAttribute('data-before') || 'Delivered from 24 hours in {city}';
    var after = el.getAttribute('data-after') || 'Delivered from 24 hours in {city}';
    var now = dubaiSeconds();
    var cut = cutoff * 3600;
    var text;
    if (now < cut) {
      var rem = cut - now;
      var rh = Math.floor(rem / 3600);
      var rm = Math.floor((rem % 3600) / 60);
      var t = rh > 0 ? rh + 'h ' + rm + 'm' : rm + 'm';
      text = before.replace('{time}', '<b>' + t + '</b>').replace('{city}', city);
    } else {
      text = after.replace('{city}', city);
    }
    line.innerHTML = text;
  }

  function tick() {
    var els = document.querySelectorAll('fg-delivery-countdown');
    for (var i = 0; i < els.length; i++) update(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  setInterval(tick, 30000);
})();
